'use strict';

module.exports = function(fn) {
    var readyStateCheckInterval = window.setInterval(function () {
        if (document.readyState === 'complete') {
            window.clearInterval(readyStateCheckInterval);
            fn();
        }
    }, 10);
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/util/ready.js
 ** module id = 29
 ** module chunks = 0
 **/